// JsFromRoutes CacheKey 46b96f9c2357f8ed5ca9bb683b2d6e64
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/storage/representations/redirect/:signed_blob_id/:variation_key/*filename'),
  showGet: /* #__PURE__ */ definePathHelper('get', '/storage/representations/:signed_blob_id/:variation_key/*filename'),
}
